import React from 'react';
import styles from './index.module.scss';

export default function Footer() {
  return (
    <p className={styles.footer}>
      <span className={styles.logo}>EzMonit</span>
      <br />
      <span className={styles.copyright}>© 2019-Now Ezcon Inc.</span>
    </p>
  );
}
